
export const alertVariants = {
  default: {
    containerClassName: 'bg-neutral-op-8',
    textClassName: 'text-warning',
  },
  error: {
    containerClassName: 'bg-danger-op',
    textClassName: 'text-danger-soft',
  },
  warning: {
    containerClassName: 'bg-yellow-op-2',
    textClassName: 'text-warning',
  },
  info: {
    containerClassName: 'bg-sky-400/15',
    textClassName: 'text-sky-400',
  },
  success: {
    containerClassName: 'bg-success-op',
    textClassName: 'text-green-500',
  },
}
